import { HugeiconsIcon } from "@hugeicons/react";
import { File02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

type Props = {
  description: string;
  title?: string;
  className?: string;
};

export const AnalyticsEmptyState = ({
  description,
  title = "No data to show",
  className
}: Props) => (
  <div
    className={cx(
      "flex flex-col items-center justify-center min-h-[120px]",
      className
    )}
  >
    <div className="h-[100px] w-[100px] flex items-center justify-center rounded-full bg-alpha-20 mx-auto mb-4">
      <HugeiconsIcon
        icon={File02Icon}
        size="32"
        className="text-content-400"
        strokeWidth={1}
      />
    </div>

    <h2 className="font-bold text-content-500 text-base mb-2 text-center">
      {title}
    </h2>

    <p className="text-sm font-medium text-content-300 text-center">
      {description}
    </p>
  </div>
);
